import { motion } from 'framer-motion'
import React from 'react'

import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'

import { showPhoneButton } from './styles.css'

type Props = {
  buttonLabel: string
  clickRevealButtonHandler: VoidFunction
  shouldRevealContent: boolean
}

const RevealButton: React.FC<Props> = ({
  buttonLabel,
  children,
  clickRevealButtonHandler,
  shouldRevealContent,
  ...props
}) => {
  return shouldRevealContent ? (
    <motion.div
      animate={{ scale: [1, 1.02, 1] }}
      className={sprinkles({ display: 'inline-block' })}
      transition={{ duration: 0.3, ease: 'easeOut' }}
    >
      {children}
    </motion.div>
  ) : (
    <button className={showPhoneButton} {...props} onClick={clickRevealButtonHandler}>
      {buttonLabel}
    </button>
  )
}

export default RevealButton
